const doc = [({"en":({"adminButtonUser":({"backToUserIndex":"BACK TO MEMBER LIST"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;